export const LeasingTransactionsPermissions = {
  ViewAndSearchInMainAccountsLeaseTransactionsPage:
  {
    permissionsId: 'c81a04bd-01cc-4c56-c9d6-08d94f66fc61',
    permissionsName: 'View and Search in main Accounts Lease Transactions page',
    componentsId: null,
    components: null
  },
  ViewAccountsLeaseTransactionPage:
  {
    permissionsId: '6fade3eb-52f3-4c9a-7c98-08d9686ecc35',
    permissionsName: 'View Accounts lease transaction page',
    componentsId: null,
    components: null
  },
  ViewTransactionsDetails:
  {
    permissionsId: 'f6661353-8f57-4ba5-7c99-08d9686ecc35',
    permissionsName: 'View Transactions Details',
    componentsId: null,
    components: null
  },
  ViewContactDetails:
  {
    permissionsId: '50456bf5-adc2-43cc-7c9a-08d9686ecc35',
    permissionsName: 'View Contact Details',
    componentsId: null,
    components: null
  },
  ViewReferenceDetails:
  {
    permissionsId: 'f4e50ee9-a0ea-49a2-7c9b-08d9686ecc35',
    permissionsName: 'View Reference Details',
    componentsId: null,
    components: null
  },
  UpdateReferenceDetailsInLeaseTransactions:
  {
    permissionsId: 'e053d6fd-4149-4ca9-7c9c-08d9686ecc35',
    permissionsName: 'Update Reference Details In lease Transactions (Account)',
    componentsId: null,
    components: null
  },

  ViewEarning:
  {
    permissionsId: '3dee6daa-7ca4-4ab9-7c9d-08d9686ecc35',
    permissionsName: 'View Earning',
    componentsId: null,
    components: null
  },
  ViewInvoicesInLeaseTransactions:
  {
    permissionsId: '9b01dbb3-6142-477d-7c9e-08d9686ecc35',
    permissionsName: 'View Invoices In lease Transactions (Account)',
    componentsId: null,
    components: null
  },
  ViewChequeRequestDetails:
  {
    permissionsId: '7c89836d-f216-4753-7c9f-08d9686ecc35',
    permissionsName: 'View Cheque Request Details',
    componentsId: null,
    components: null
  },
  ViewAllChequeRequest:
  {
    permissionsId: '74781a8e-95b5-40c4-7ca0-08d9686ecc35',
    permissionsName: 'View All Cheque Request',
    componentsId: null,
    components: null
  },
  AddChequeRequestForm:
  {
    permissionsId: 'e24442b3-995c-411f-7ca1-08d9686ecc35',
    permissionsName: 'Add Cheque Request Form',
    componentsId: null,
    components: null
  }

};
